/* ============================================================
   Kuhle Eifel – Kuhfleck-Icon Block
   Scroll-Reveal · SVG-Inlining
   ============================================================ */
(function () {
  'use strict';

  /* ── SVG Inlining ─────────────────────────────────────── */
  function inlineSVG(img) {
    var src = img.getAttribute('src') || '';
    if (!src || src.toLowerCase().indexOf('.svg') === -1) return;
    fetch(src, { mode: 'cors' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (t) {
        var svg = new DOMParser().parseFromString(t, 'image/svg+xml').querySelector('svg');
        if (!svg) return;
        svg.style.cssText = 'width:100%;height:100%;display:block';
        svg.removeAttribute('width'); svg.removeAttribute('height');
        img.parentNode.replaceChild(svg, img);
      }).catch(function () {});
  }

  /* ── Scroll-Reveal State ──────────────────────────────── */
  var pending = [];
  var listening = false;

  function hide(el) {
    el.style.visibility = 'hidden';
    var e = el.dataset.keKfEntrance || 'fade-in';
    if (e === 'slide-up')  el.style.transform = 'translateY(30px)';
    if (e === 'zoom-in')   el.style.transform = 'scale(0.8)';
    if (e === 'bounce-in') el.style.transform = 'scale(0.6)';
  }

  function reveal(el) {
    var delay = parseInt(el.dataset.scrollDelay, 10) || 0;
    var e = el.dataset.keKfEntrance || 'fade-in';
    setTimeout(function () {
      var tr = e === 'bounce-in'
        ? 'visibility 0s,opacity .5s ease,transform .5s cubic-bezier(.34,1.56,.64,1)'
        : 'visibility 0s,opacity .6s ease,transform .6s ease';
      el.style.transition = tr;
      el.style.visibility = 'visible';
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.classList.add('ke-kf-visible');
      setTimeout(function () {
        el.style.cssText = el.style.cssText
          .replace(/visibility:[^;]+;?/g, '')
          .replace(/opacity:[^;]+;?/g, '')
          .replace(/transform:[^;]+;?/g, '')
          .replace(/transition:[^;]+;?/g, '')
          .replace(/will-change:[^;]+;?/g, '');
      }, 900);
    }, delay);
  }

  function check() {
    if (!pending.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var next = [];
    for (var i = 0; i < pending.length; i++) {
      var r = pending[i].getBoundingClientRect();
      if (r.top < vh - 30 && r.bottom > 0) {
        reveal(pending[i]);
      } else {
        next.push(pending[i]);
      }
    }
    pending = next;
    if (!pending.length) stopListening();
  }

  function onEvent() { requestAnimationFrame(check); }

  function startListening() {
    if (listening) return;
    listening = true;
    window.addEventListener('scroll', onEvent, { passive: true });
    window.addEventListener('resize', onEvent, { passive: true });
  }

  function stopListening() {
    listening = false;
    window.removeEventListener('scroll', onEvent);
    window.removeEventListener('resize', onEvent);
  }

  /* ── Scan & Init ──────────────────────────────────────── */
  function scan() {
    /* SVG inlining */
    var imgs = document.querySelectorAll('.ke-kf-bg img, .ke-kf-icon img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].dataset.keI) { imgs[i].dataset.keI = '1'; inlineSVG(imgs[i]); }
    }

    /* Scroll-reveal */
    var els = document.querySelectorAll('.ke-kf-container[data-ke-kf-entrance]:not(.ke-kf-visible)');
    for (var j = 0; j < els.length; j++) {
      if (els[j].dataset.keR) continue;
      els[j].dataset.keR = '1';
      hide(els[j]);
      pending.push(els[j]);
    }

    if (pending.length) {
      startListening();
      /* Check sofort + nach kurzem Delay (Layout kann sich noch ändern) */
      requestAnimationFrame(check);
      setTimeout(check, 300);
      setTimeout(check, 1000);
    }
  }

  /* Starte so früh wie möglich, aber auch nach DOMContentLoaded */
  scan();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  }
  /* Nochmal nach komplettem Laden (Bilder, Fonts, etc.) */
  window.addEventListener('load', function () { setTimeout(scan, 100); });

  /* Shopify Editor */
  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 200); });
})();
